module.exports = __webpack_public_path__ + "media/pro/greenCheck-filled-41fb315a.svg";